const numberWithCommas = (x) => {
  if(x === 0){
    return x;
  }else{
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export default numberWithCommas;